export default __webpack_public_path__ + "static/media/Path3478.d40faf72.svg";